/**
 * add zoom capabilities to the given echarts instance
 * @param {*} echarts echarts instance
 */
export function withZoom(echarts) {
  const defaultSeriesChoser = (series) => series[0];

  /**
   * gets the zoom of the given option
   * @param chooseSerie [optional] should choose what serie in which the
   * zoom must be obtained. If nothing is passed the zoom will be obtained
   * from the first serie
   */
  echarts.getZoomOf = function (option, chooseSerie = defaultSeriesChoser) {
    const serie = chooseSerie(option.series);
    const { zoom } = serie;
    return zoom;
  };

  /**
   * gets the current zoom of this echarts instance.
   * @param {*} chooseSerie [optional] should choose what serie in which the
   * zoom must be obtained. If nothing is passed the zoom will be obtained
   * from the first serie
   */
  echarts.getCurrentZoom = function (chooseSerie = defaultSeriesChoser) {
    const currentOption = this.getOption();
    const zoom = this.getZoomOf(currentOption, chooseSerie);
    return zoom;
  };

  /**
   * increments the current zoom by the given value.
   * ps: supports negative value
   */
  echarts.incrementZoom = function (value) {
    const currentOption = this.getOption();

    const seriesWithZoom = currentOption.series.map((serie) => {
      const currentZoom = serie.zoom;
      const newZoom = currentZoom + value;

      return {
        ...serie,
        zoom: newZoom,
      };
    });

    this.setOption({
      series: seriesWithZoom,
    });
  };

  return echarts;
}
